import { apiFetch } from "./http";

// Tanıtım listesinden çıkanlar (ETK 6563 opt-out).
//
// İki ayrı okuma biçimi var, karıştırma:
//   - detail YOK  → {"items": ["a@x", ...]}  gönderim betiğinin ayıklama listesi
//   - detail=1    → {"rows":  [{...}]}       bu panelin gördüğü satırlar
// Betiğin okuduğu biçim değiştirilmemeli; panel için ayrı dal açıldı.

export type Unsubscribe = {
  id: number;
  email: string;
  /** "web" = sitedeki form, "mail" = List-Unsubscribe başlığı vb. */
  source: string;
  created_at: string;
};

// IP alanı BİLEREK yok — tabloda duruyor ama panele çıkarılmıyor
// (bkz. models.MailUnsubscribe).

export async function listUnsubscribes(
  opts: { q?: string; limit?: number } = {},
): Promise<Unsubscribe[]> {
  const p = new URLSearchParams({ detail: "1" });
  if (opts.q) p.set("q", opts.q);
  if (opts.limit) p.set("limit", String(opts.limit));
  const res = await apiFetch(`/api/v1/admin/mail/unsubscribes?${p}`);
  if (!res.ok) {
    const d = (await res.json().catch(() => ({}))) as { error?: string };
    throw new Error(d.error || "Liste alınamadı");
  }
  const d = (await res.json()) as { rows?: Unsubscribe[] };
  return d.rows ?? [];
}
